import React from "react";
import FilePage from "../FilePage/FilePage";

class PersonListAttachment extends React.Component {
  render() {
    const { user } = this.props;

    return (
      <FilePage
        table={"user"}
        id={user.id}
        title={"ضمیمه های " + user.fullname}
        handleBack={this.props.handleBack}
      />
    );
  }
}

export default PersonListAttachment;
